export default "__VITE_ASSET__Cc9CQd20__"